import React from 'react';
import { Input } from '../input';
import { DateValue } from './types';
import { toHijri, fromHijri } from '@/utils/date/hijri';

interface DateInputProps {
  value: DateValue;
  onChange: (value: DateValue) => void;
  isHijri?: boolean;
}

export function DateInput({ value, onChange, isHijri = false }: DateInputProps) {
  const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newYear = e.target.value.replace(/[^0-9٠-٩]/g, '')
      .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - '٠'.charCodeAt(0)));
    onChange({ ...value, year: newYear });
  };

  const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMonth = e.target.value.replace(/[^0-9٠-٩]/g, '')
      .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - '٠'.charCodeAt(0)));
    
    if (parseInt(newMonth) <= 12 || newMonth === '') {
      onChange({ ...value, month: newMonth });
    }
  };

  const handleDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDay = e.target.value.replace(/[^0-9٠-٩]/g, '')
      .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - '٠'.charCodeAt(0)));
    
    const maxDays = isHijri ? 30 : 31;
    if (parseInt(newDay) <= maxDays || newDay === '') {
      onChange({ ...value, day: newDay });
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        value={value.year}
        onChange={handleYearChange}
        placeholder="السنة"
        maxLength={4}
        className="text-center"
      />
      <Input
        value={value.month}
        onChange={handleMonthChange}
        placeholder="الشهر"
        maxLength={2}
        className="text-center"
      />
      <Input
        value={value.day}
        onChange={handleDayChange}
        placeholder="اليوم"
        maxLength={2}
        className="text-center"
      />
    </div>
  );
}